<template>
  <!-- <img src="@/assets/img/TSTAR_LOGO.png" class="" style="position: absolute;width: 200px; background-color: aliceblue; backdrop-filter: blur(5px); padding: 2rem 10px; border-radius: 0 1rem 1rem 1rem;"> -->
  <b-navbar id="navbar" toggleable="sm" type="light" class="">
    <!-- <div class="container"> -->
      <b-navbar-brand to="/">
        <img src="@/assets/img/TSTAR_LOGO.png" class="img-fluid logo_img">
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav  class="ml-">
          <b-nav-item to="/login" v-if="!$store.state.jwt">
            <b-button class="nav_btn" size="sm">登入</b-button>
          </b-nav-item>
          <b-nav-item @click="$store.commit('logout')" v-if="$store.state.jwt&&$store.getters.loginRole==='staff'">
            <b-button variant="outline-danger" size="sm" >登出</b-button>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav  class="ml-auto">
          <!-- 可以切換語言的頁面:首頁 -->
          <b-navbar-nav v-if="$store.state.showLang" class="langNav smtxt rounded">
            <b-nav-item :active="this.$i18n.locale==='tw'" @click="switchLang('tw')">中文</b-nav-item>
            <b-nav-item :active="this.$i18n.locale==='en'" @click="switchLang('en')">English</b-nav-item>
            <b-nav-item :active="this.$i18n.locale==='jp'" @click="switchLang('jp')">日本語</b-nav-item>
          </b-navbar-nav>
          <!-- <b-nav-item to="/member-center" v-if="$store.state.jwt">會員中心</b-nav-item> -->
          <!-- <b-nav-item @click="showLoginModal" v-if="$store.getters.loginRole!=='staff'&&!$store.state.jwt">註冊/登入</b-nav-item> -->
          <b-nav-item @click="$store.commit('logout')" v-if="$store.getters.loginRole!=='staff'&&$store.state.jwt">登出</b-nav-item>
          <b-nav-item to="/admin/tours" v-if="$store.state.jwt&&$store.getters.loginRole==='staff'">管理後台</b-nav-item>
          <!-- <b-nav-item to="/checkout">填寫訂單</b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    <!-- </div> -->
    <b-modal id="loginModal"
      centered hide-header hide-footer>
      <b-form class="text-center p-4 blurform" @keydown.enter.prevent>
        <strong v-if="!isLoginOrSignup">註冊 / 登入</strong>
        <strong v-else>{{isLoginOrSignup==='login'?'登入':'註冊'}}</strong>
        <div class="text-left my-4">
          <b-form-group
            label='電子信箱'
            label-for='input_email'
            label-cols-sm="3"
            content-cols-sm
            invalid-feedback="請輸入正確格式的電子信箱">
            <b-form-input
              autocomplete
              :disabled="isLoginOrSignup!==null"
              id="input_email"
              required
              type='text'
              placeholder="請輸入電子信箱"
              v-model="loginForm.email"
              :state="state.valiEmail"
              @blur="blurEmail=true"
            ></b-form-input>
          </b-form-group>

          <!-- 註冊 -->
          <div v-if="isLoginOrSignup==='signup'">
            <b-form-group
              label='密碼'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="密碼至少為6碼">
              <b-form-input
                required
                type='password'
                placeholder="請輸入密碼"
                v-model="loginForm.psw"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label='密碼確認'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入相同的密碼"
              :state="state.pswDBCheck">
              <b-form-input
                required
                type='password'
                placeholder="請再次輸入密碼"
                v-model="pswCheck"
                :state="state.pswDBCheck"
                @blur="blur_pswCheck=true"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label='暱稱'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入暱稱">
              <b-form-input
                autocomplete="off"
                required
                placeholder="請輸入暱稱"
                v-model="loginForm.nick_name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label='性別'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入性別">
                <b-form-radio
                  v-model="loginForm.gender"
                  name="gender"
                  value= 男
                  class="custom-control-inline"
                >男
                </b-form-radio>
                <b-form-radio
                  v-model="loginForm.gender"
                  name="gender"
                  value= 女
                  class="custom-control-inline"
                >女
                </b-form-radio>
                <b-form-radio
                  v-model="loginForm.gender"
                  name="gender"
                  :value= null
                  class="custom-control-inline"
                >不公開
                </b-form-radio>
            </b-form-group>
            <b-form-group
              label='生日'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入生日">
                <b-row>
                  <b-col cols="12" sm="4" class="pr-sm-0 mb-1">
              <b-form-input
                autocomplete="off"
                class="hideArrow"
                required
                type='number'
                placeholder="西元年"
                v-model="loginForm.birthY"
              ></b-form-input>
              </b-col>
                  <b-col cols="6" sm="4" class="px-sm-1 mb-1">
              <b-form-input
                autocomplete="off"
                class="hideArrow"
                required
                type='number'
                placeholder="月"
                v-model="loginForm.birthM"
              ></b-form-input>
              </b-col>
                  <b-col cols="6" sm="4" class="pl-sm-0 mb-1">
              <b-form-input
                autocomplete="off"
                class="hideArrow"
                required
                type='number'
                placeholder="日"
                v-model="loginForm.birthD"
              ></b-form-input>
              </b-col>
              </b-row>
            </b-form-group>
            <b-form-group
              label='電話(選填)'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入聯絡電話">
              <b-form-input
                autocomplete="off"
                class="hideArrow"
                required
                type='number'
                placeholder="請輸入聯絡電話"
                v-model="loginForm.phone"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label='驗證碼'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入下方的四位數驗證碼，若看不清楚，可點選圖片重新生成">
              <b-form-input
                autocomplete="off"
                class="hideArrow"
                required
                type='number'
                placeholder="請輸入下方四位數驗證碼"
                v-model="vali_code"
                :state="state.checkVCode"
              ></b-form-input>
            </b-form-group>
          </div>
          <!-- 註冊END -->

          <!-- 登入 -->
          <div v-if="isLoginOrSignup==='login'">
            <b-form-group
              label='密碼'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="密碼至少為6碼">
              <b-form-input
                required
                type='password'
                placeholder="請輸入密碼"
                v-model="loginForm.psw"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label='驗證碼'
              label-cols-sm="3"
              content-cols-sm
              invalid-feedback="請輸入下方的四位數驗證碼，若看不清楚，可點選圖片重新生成">
              <b-form-input
                autocomplete="off"
                class="hideArrow"
                required
                type='number'
                placeholder="請輸入下方四位數驗證碼"
                v-model="vali_code"
                :state="state.checkVCode"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-btn
        ref="nextBtn"
        @click="checkLoginOrSignup()" v-if="!isLoginOrSignup" variant="dark" @keyup.enter="checkLoginOrSignup()">下一步</b-btn>
        <!-- <b-btn @click="checkLoginOrSignup('login')" v-if="!isLoginOrSignup" variant="dark">下一步登入</b-btn> -->

        <!-- 完成登入或註冊按鈕 -->
        <div v-if="isLoginOrSignup==='signup'">
          <div class="identifyCode" @click="refreshCode">
            <Identify :identifyCode="identifyCode"></Identify>
          </div>
          <b-button class="okBtn" @click='singUp()' :disabled="singUpDisabled" @keyup.enter="singUp()">
            註冊
          </b-button>
        </div>

        <div v-if="isLoginOrSignup==='login'">
          <div class="identifyCode" @click="refreshCode">
            <Identify :identifyCode="identifyCode"></Identify>
          </div>
          <div class="d-flex">
            <!-- <router-link class="mx-auto smallLink" to='/forgot'>忘記密碼</router-link> -->
          </div>
          <b-button class="okBtn" @click='login()' :disabled="loginDisabled" @keyup.enter="login()">
            登入
          </b-button>
        </div>
        <div @click="isLoginOrSignup=null, blurEmail=false" @keyup.enter="isLoginOrSignup=null, blurEmail=false"
          v-if="isLoginOrSignup!==null" class="mt-3 subtxt pointer smtxt d-inline-block" role="button" tabindex="0">
          上一步
        </div>
        <div class="mt-3 smtxt">
          <a href="/tours/forgot/member">忘記密碼</a>
        </div>
      </b-form>
    </b-modal>
  </b-navbar>
</template>

<script>
import Identify from '@/components/Identify.vue'
import validator from 'validator'
export default {
  components: {
    Identify
  },
  data () {
    return {
      blur_pswCheck: false,
      blurEmail: false,
      pswCheck: '',
      isLoginOrSignup: null,
      // 驗證碼
      identifyCode: '',
      loginForm: {
        email: '',
        psw: '',
        nick_name: '',
        phone: '',
        gender: null,
        birthY: '',
        birthM: '',
        birthD: ''
      },
      vali_code: ''
    }
  },
  computed: {
    // 驗證碼、必填、密碼確認
    // 密碼規則
    singUpDisabled () {
      if ((this.vali_code !== this.identifyCode) || !this.loginForm.email || !this.loginForm.psw ||
        !this.loginForm.nick_name || !this.loginForm.birthD || !this.loginForm.birthM ||
        !this.loginForm.birthY || !this.state.pswDBCheck) {
        return true
      } else {
        return false
      }
    },
    loginDisabled () {
      if ((this.vali_code !== this.identifyCode) || !this.loginForm.email || !this.loginForm.psw) {
        return true
      } else { return false }
    },
    state () {
      return {
        pswDBCheck: !this.blur_pswCheck || this.pswCheck === '' ? null : this.loginForm.psw === this.pswCheck,
        valiEmail: !this.blurEmail ? null : validator.isEmail(this.loginForm.email),
        checkVCode: this.vali_code === '' ? null : this.vali_code === this.identifyCode
      }
    }
  },
  methods: {
    async checkJWT () {
      try {
        const { data } = await this.api.get('php_modules2/member.php?type=jwt', {
          headers: {
            authorization: this.$store.state.jwt
          }
        })
        console.log(data)
        // if (data.success) {
        //   await this.$store.commit('checkJWT', data.id)
        // } else
        if (data.message === 'Expired token') {
          await this.$swal.fire({
            icon: 'error',
            text: '請重新登入',
            showConfirmButton: false,
            timer: 1500
          })
          this.$store.commit('logout')
        } else {
          alert(data.message)
          this.$store.commit('logout')
        }
      } catch (error) {
        console.log(error)
        this.$store.commit('logout')
      }
    },
    // 註冊
    async singUp () {
      console.log(this.loginForm)
      try {
        const { data } = await this.api.post('php_modules2/member.php?type=c', this.loginForm)
        console.log(data)
        if (data.success) {
          this.$bvModal.hide('loginModal')
          await this.$swal({
            type: 'success',
            text: '已送出驗證信，請至 ' + this.loginForm.email + ' 收信，並點擊連結完成註冊。若沒收到信件，請檢查垃圾信件夾。'
          })
          this.loginForm = JSON.parse(JSON.stringify(this.loginFormCopy))
          this.blurEmail = false
          this.isLoginOrSignup = null
        } else alert(data.message)
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: '錯誤',
          text: error
        })
      }
    },
    // 登入
    async login () {
      console.log(this.loginForm)
      try {
        const { data } = await this.api.post('php_modules2/member.php?type=login', this.loginForm)
        console.log(data)
        if (data.success) {
          this.$store.commit('login', data)
          this.$swal({
            icon: 'success',
            text: '登入成功',
            showConfirmButton: false,
            timer: 1000
          })
          this.$bvModal.hide('loginModal')
          this.$router.go(0)
        } else {
          this.refreshCode()
          this.vali_code = ''
          alert(data.message)
        }
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: '錯誤',
          text: error
        })
      }
    },
    // 確認此EMAIL是否有註冊過，以判斷使用者是要登入還是註冊
    async checkLoginOrSignup () {
      this.$refs.nextBtn.disabled = true // 讓按鈕disabled以免使用者重複按
      // 先檢查EMAIL格式，若格式正確才繼續
      this.blurEmail = true
      if (!this.state.valiEmail) {
        this.$refs.nextBtn.disabled = false
        return
      }
      try {
        // console.log(this.api)
        const { data } = await this.api.post('php_modules2/member.php?type=email_check', this.loginForm)
        console.log(data)
        // 決定下一步是登入or註冊
        this.isLoginOrSignup = data.message
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: '錯誤',
          text: error
        })
      }
    },
    // 顯示註冊/登入MODAL
    showLoginModal () {
      this.loginForm = JSON.parse(JSON.stringify(this.loginFormCopy))
      this.blurEmail = false
      this.isLoginOrSignup = null
      this.refreshCode()
      this.$bvModal.show('loginModal')
    },
    // 選英文日文時，切換至外文首頁
    switchLang (x) {
      // 如果重複點選一樣的語言，則不繼續
      if (x === localStorage.getItem('locale')) return
      this.$i18n.locale = x
      localStorage.setItem('locale', x)
      if (x === 'tw') {
        this.$router.push('/')
      } else {
        this.$router.push('/lang/' + x)
        // this.$router.go(0)
      }
    }
  },
  // 進頁面生成隨機驗證碼
  async mounted () {
    // if (this.$route.path === '/signup') { this.$bvModal.show('loginModal') }
    // console.log(this.$store.getters.loginRole)
    this.loginFormCopy = JSON.parse(JSON.stringify(this.loginForm))
    this.refreshCode()
  }
}
</script>

<style lang="scss">
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
#navbar {
  .logo_img {
    width: 180px;
  }
  // font-family: 'Noto Sans', sans-serif, 'Noto Sans JP';
  .langNav {
    position: relative;
    .nav-link.active {
      font-weight: 500;
    }
  }
  padding: 0 !important;
  // background-color: #ffedce;
  // box-shadow: 5px 5px 5px rgb(0, 0, 0, 0.05);
  // border-bottom: 1px solid rgb(231, 231, 231);
  .navbar-toggler {
    border: none;
  }
  .nav-item {
    margin: 0 auto;
  }
  .navbar-brand {
    width: 240px;
  }

  .customer_card {
    background: linear-gradient(var(--myblue2) 50px,#fff 50px);
    color: var(--mytext);
    padding: .8rem 1.6rem;
    // border: 1px solid rgb(224, 224, 224);
    box-shadow: 0px 5px 10px rgb(0, 0, 0, 0.2);
    border-radius: 10px;
    margin: 1rem 0;
    label {
      display: block;
      font-weight: 500;
    }
    .title {
      font-size: 1.1rem;
      font-weight: 500;
      margin-bottom: 1rem;
    }
  }
  .btn-secondary {
    color: var(--mytext);
    background: #fff;
    border: 1px solid var(--mytext);
    &:hover {
      color: #fff;
      background: var(--mytext);
      border: 1px solid var(--mytext);
    }
  }
  @media (min-width:576px) {
  .logo_img {
    width: auto;
  }
    padding: 0 30px !important;
    .langNav .nav-item:nth-child(2) {
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
      }
    .langNav {
      border: 1px solid rgb(0, 0, 0, 0.2);
    }
  }
}

.modal-dialog {
  .modal-header {
    border: none;
    background-color: var(--myblue2);
    button {
      color: var(--myblue);
    }
  }
  .modal-title {
    letter-spacing: 1px;
    font-size: 1rem;
    font-weight: 500;
    color: var(--myblue);
  }
  .form-group {
    margin-bottom: 1rem;
  }
  input {
    // margin-bottom: 10px;
  }
  .modal-footer {
    border: none;
    padding: 0 auto .8rem;
    justify-content: center;
    button.btn-primary {
      background-color: var(--myblue);
      border: none;
      padding: .5rem 1.8rem;
      border-radius: 50px;
      &:hover {
        filter: brightness(1.1);
      }
    }
    button {
      border: none;
      padding: .5rem 1.8rem;
      border-radius: 50px;
    }
  }
  .switch_btn {
    font-size: .8rem;
  }

  // 數字input隱藏箭頭
  .hideArrow::-webkit-outer-spin-button,
  .hideArrow::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .hideArrow {
    -moz-appearance: textfield;
  }
}
#loginModal {
  .modal-content {
    background: none;
    border: none;
  }
  .modal-body {
    padding: 0;
  }
}
</style>
